export default {
  btnContainer: {
    paddingVertical: 12,
    marginBottom: 3,
    borderRadius: 2,

    flexDirection: "row" as "row",
    position: "relative",
  },

  title: {
    fontSize: 15,
    textAlign: "center",
    color: "#c8c8c8",
  },

  icon: {
    width: 24,
    height: 24,
    alignSelf: "center",
  },

  bordered: {
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#e8e8e8",
  },

  activeBorder: {
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "black",
  },

  leftIcon: {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    justifyContent: "center",
  },

  rightIcon: {
    top: 0,
    bottom: 0,
    right: 0,
    position: "absolute",
    justifyContent: "center",
  },
};
